
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MOTORISTA_FOLGA_MOTIVO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'MOTORISTA_FOLGA_MOTIVO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'MOTORISTA_FOLGA_MOTIVO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'MOTORISTA_FOLGA_MOTIVO_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome
				}))
			};

        default:
            return state;
    }
}
